// A counterparty's KYC review on its profile (TX-US-0035). Compliance fills the sheet in and
// saves it against the version read; everyone else reads what was answered. What the
// counterparty record already holds is shown from it, above the sheet, and not typed again.

import { getKycReview, saveKycReview } from '../../api.js';
import { countryLabel } from '../../countries.js';
import SheetPanel from '../sheets/SheetPanel.jsx';
import * as kit from './sheet.js';

const COPY = {
  heading: 'KYC review',
  preparedBy: 'Reviewed by',
  save: 'Save KYC review',
  saved: 'KYC review saved.',
  coreKind: 'kyc_core_missing',
  keeps: 'A counterparty past KYC keeps its',
  stale: 'This review changed since you opened it. Reload to see the current version.',
};

export default function KycReview({ counterparty, canEdit, onSaved }) {
  return (
    <SheetPanel id="kyc-review" counterpartyId={counterparty.counterparty_id} canEdit={canEdit}
                onSaved={onSaved} load={getKycReview} save={saveKycReview} kit={kit} copy={COPY}>
      <dl className="deal-fields kyc-subject">
        <dt>Vendor name</dt>
        <dd>{counterparty.legal_name ?? counterparty.name}</dd>
        <dt>Registration number</dt>
        <dd>{counterparty.registration_number ?? '—'}</dd>
        <dt>Country of incorporation</dt>
        <dd>{counterparty.country ? countryLabel(counterparty.country) : '—'}</dd>
      </dl>
    </SheetPanel>
  );
}
